import React, { useState } from "react";

/** Mapa de colores (fondos sólidos en la cabecera, como antes) */
const tones = {
  emerald: "bg-emerald-600",
  amber: "bg-amber-600",
  sky: "bg-sky-600",
  fuchsia: "bg-fuchsia-600",
  slate: "bg-slate-700",
};

/** Sección plegable con lista + rol opcional (cerrada por defecto) */
const Section = ({ title, items = [], role = "", tone = "emerald" }) => {
  const [open, setOpen] = useState(false); // ⬅️ cerrada por defecto
  const hasContent = (items?.length || role);
  if (!hasContent) return null;

  const toneBg = tones[tone] || tones.emerald;

  return (
    <div className="rounded-2xl border overflow-hidden bg-white/85 backdrop-blur">
      <button
        onClick={() => setOpen((v) => !v)}
        className={`w-full flex items-center justify-between gap-3 px-4 py-3 font-semibold ${toneBg} text-white`}
      >
        <span>{title}</span>
        <span className="text-xl leading-none">{open ? "▾" : "▸"}</span>
      </button>

      {open && (
        <div className="p-4 space-y-2">
          {items?.length ? (
            <ul className="space-y-1.5 leading-relaxed">
              {items.map((t, i) => (
                <li key={i} className="flex gap-2">
                  <span className="select-none mt-[3px] inline-block min-w-[1em] text-center text-slate-400">–</span>
                  <span>{t}</span>
                </li>
              ))}
            </ul>
          ) : null}

          {role ? (
            <p className="text-sm whitespace-pre-line text-gray-700">{role}</p>
          ) : null}
        </div>
      )}
    </div>
  );
};

/** Espera prepare = { enganxem:{items,role}, ... } */
export default function SessionAccordion({ prepare, labels }) {
  return (
    <div className="space-y-4">
      <Section title={labels.hook}      items={prepare.enganxem?.items}  role={prepare.enganxem?.role}  tone="emerald" />
      <Section title={labels.explore}   items={prepare.explorem?.items}  role={prepare.explorem?.role}  tone="amber" />
      <Section title={labels.explain}   items={prepare.expliquem?.items} role={prepare.expliquem?.role} tone="sky" />
      <Section title={labels.elaborate} items={prepare.elaborem?.items}  role={prepare.elaborem?.role}  tone="fuchsia" />
      <Section title={labels.assess}    items={prepare.avaluem?.items}   role={prepare.avaluem?.role}   tone="slate" />
    </div>
  );
}
